import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useDelEvidenceMutation, useListEvidencesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Evidence',
  props: {
    filters: Object,
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var attrs = useAttrs();
    var headers = computed(function () {
      return [{
        value: 'id',
        sortable: true
      }, {
        value: 'websiteUrl',
        width: '450'
      }, {
        value: 'description'
      }, {
        value: 'comment'
      }, {
        value: 'countEvidenceLinks',
        width: '20px'
      }, {
        value: 'actions',
        width: '85px'
      }].filter(function (o) {
        var _attrs$headers;
        return attrs === null || attrs === void 0 ? void 0 : (_attrs$headers = attrs.headers) === null || _attrs$headers === void 0 ? void 0 : _attrs$headers.includes(o.value);
      }).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          sortable: col.sortable || false
        });
      }) || [];
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var search = ref('');
    var variables = computed(function () {
      return {
        filters: props.filters,
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListEvidencesQuer = useListEvidencesQuery(variables, {
        fetchPolicy: 'network-only'
      }),
      result = _useListEvidencesQuer.result,
      refetch = _useListEvidencesQuer.refetch,
      loading = _useListEvidencesQuer.loading;
    var items = computed(function () {
      var _result$value$listEvi, _result$value;
      return (_result$value$listEvi = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listEvidences) !== null && _result$value$listEvi !== void 0 ? _result$value$listEvi : [];
    });
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countEvidences) || 0;
    });
    var _useDelEvidenceMutati = useDelEvidenceMutation(),
      delEvidence = _useDelEvidenceMutati.mutate;
    watch(items, function (nextItems) {
      var _props$value, _props$value2;
      var validEvidenceIds = new Set(nextItems.map(function (item) {
        return item.id;
      }));
      var nextSelection = ((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : []).filter(function (id) {
        return validEvidenceIds.has(id);
      });
      if (nextSelection.length !== ((_props$value2 = props.value) !== null && _props$value2 !== void 0 ? _props$value2 : []).length) {
        emit('input', nextSelection);
      }
    });
    var handleDelEvidence = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(id, dialog) {
        var _result$data;
        var result, _props$value3, _props$value4;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return delEvidence({
                id: id
              });
            case 2:
              result = _context.sent;
              if ((result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.delEvidence) === false) {
                window.$nuxt.$emit('userError', {
                  color: 'red',
                  message: 'Unable to delete evidence link created by another account.'
                });
                dialog.value = false;
              } else {
                refetch();
                if (((_props$value3 = props.value) !== null && _props$value3 !== void 0 ? _props$value3 : []).includes(id)) {
                  emit('input', ((_props$value4 = props.value) !== null && _props$value4 !== void 0 ? _props$value4 : []).filter(function (selectedId) {
                    return selectedId !== id;
                  }));
                }
                dialog.value = false;
                window.$nuxt.$emit('userMsg');
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleDelEvidence(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      attrs: attrs,
      props: props,
      emit: emit,
      headers: headers,
      options: options,
      search: search,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      items: items,
      itemCount: itemCount,
      delEvidence: delEvidence,
      handleDelEvidence: handleDelEvidence
    };
  }
});